export default __webpack_public_path__ + "static/media/bottom-team.88f475ad.png";